<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue'
import {RouterLink, useRouter} from 'vue-router'
import adminMatchingService from "../../services/matching/adminMatchingService";
import {usePageLoadingStore} from "../../../../stores/pageLoading";
import _ from "lodash";
import KSASecondaryButton from "../../../../components/ui-components/button/KSASecondaryButton.vue";
import MyPageResumeModal from "../../../user/components/modal/mypage/MyPageResumeModal.vue";
import { useAlertStore } from '../../../../stores/alertStore';
import KSATextButton from "../../../../components/ui-components/button/KSATextButton.vue";
import mypageCorpInfoService from "../../../user/services/mypage/mypageCorpInfoService";
import mypageUserResumeService from "@/pages/user/services/mypage/mypageUserResumeService";
const { $alert, $confirm } = useAlertStore();

const loadingStore = usePageLoadingStore()
const router = useRouter()
const { $pageListBoardNo, $toast, $gb, $gbNameKR, $number, $yyyymmddHHmmss, $applyStateGb } = getCurrentInstance().appContext.config.globalProperties;

onMounted(()=>{
  retrieveList()
})

const userApplyList = ref([]);
const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(0);
const totalCount = ref(0);
const searchOpen = ref(true)

const userMatchingResumeModal = ref(null);

const applyStateGb = ref($applyStateGb);
const applyStateGbsListRef = ref(null);
const datepickerTermsRef = ref(null)

// 검색 조건
const searchInput = ref({
  searchApplyStateGbs: ['01', '02', '03', '04', '05', '06'],
  searchInput: '',
  searchDurationType: 'all',
  startYmd: '',
  endYmd: '',
});

const searchDurationTypeGroup = ref([
  { label:"모든 기간", value: "all" },
  { label:"기간 검색", value: "term" },
])

const pageSizeGroup = ref([
  { label:"10개씩 보기", value: "10" },
  { label:"30개씩 보기", value: "30" },
  { label:"50개씩 보기", value: "50" },
  { label:"100개씩 보기", value: "100" },
  { label:"500개씩 보기", value: "500" },
])

const retrieveList = () => {
  let paramObj = {
    startYmd: searchInput.value.searchDurationType === 'all' ? '' : searchInput.value.startYmd,
    endYmd: searchInput.value.searchDurationType === 'all' ? '' : searchInput.value.endYmd,
    searchApplyStateGbs: _.map(searchInput.value.searchApplyStateGbs).join(','),
    searchInput: searchInput.value.searchInput,
    pageNumber: currentPage.value,
    size: pageSize.value,
  }
  //loadingStore.loading = true;
  adminMatchingService.retrieveAllMatchingApplicantListAdminPaging(paramObj)
      .then( async (res) => {
        //loadingStore.loading = false;
        // console.log(res);
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          userApplyList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        } else {
        }
      }).catch( (res) =>  {
    console.log(res);
    //loadingStore.loading = false;
  });
}

const clearSearchInput = () => {
  searchInput.value = {
    searchApplyStateGbs: ['01', '02', '03', '04', '05', '06'],
    searchInput: '',
    searchDurationType: 'all',
    startYmd: '',
    endYmd: '',
  }
  applyStateGbsListRef.value.initOptions();
  datepickerTermsRef.value.initDates();
}

const onClickSearch = () => {
  currentPage.value = 1;
  retrieveList();
}

const onSelectPage = (pageNo) => {
  currentPage.value = pageNo;
  retrieveList();
}

const onSelectPageSize = (option) => {
  pageSize.value = option.value;
  currentPage.value = 1;
  retrieveList();
}

// 이력서 보기
const onClickViewResume = async (resumeId) => {
  userMatchingResumeModal.value.init(false);
  userMatchingResumeModal.value.retrieveApplicantResume(resumeId, 0);
  userMatchingResumeModal.value.show();
}

// 입사지원 상태변경 joinStateGb
const onClickApplyStateGb = async (corpId, resumeId, stateGb) => {
  let modalContent = "";
  let okButtonText = "";
  if (stateGb === "02") {
    modalContent = ["지원취소 처리하시겠습니까?", "'지원취소'으로 상태가 변경됩니다."];
    okButtonText = "지원취소";
  } else if (stateGb === "03") {
    modalContent = ["서류합격 처리하시겠습니까?", "'서류합격'으로 상태가 변경됩니다."];
    okButtonText = "서류합격";
  } else if (stateGb === "04") {
    modalContent = ["서류불합격 처리하시겠습니까?", "'서류불합격'으로 상태가 변경됩니다."];
    okButtonText = "서류불합격";
  } else if (stateGb === "05") {
    modalContent = ["최종합격 처리하시겠습니까?", "'최종합격'으로 상태가 변경됩니다."];
    okButtonText = "최종합격";
  } else if (stateGb === "06") {
    modalContent = ["최종불합격 처리하시겠습니까?", "'최종불합격'으로 상태가 변경됩니다."];
    okButtonText = "최종불합격";
  }

  const ok = await $confirm(modalContent, okButtonText);

  if(ok) {
    let paramObj = {
      corpId: corpId,
      resumeId: resumeId,
      applyStateGb: stateGb,
    }
    mypageUserResumeService.updateApplyStateGb(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            //const result = res.data.result;
            $alert("변경하였습니다.");
            //$toast('', "삭제를 하였습니다.")

            retrieveList();
          } else {
            $alert("변경을 실패하였습니다.");
            console.log(res);
          }
        })
        .catch( (res) =>  {
          loadingStore.loading = false;
          $alert("변경을 실패하였습니다.");
        });
  }
}
</script>

<template>
  <div class="content">
    <div class="sub-title">
      <h3>회원별 입사지원 현황</h3>
    </div>
    <!-- s: 검색 -->
    <div class="filter-wrap" :class="{'open': searchOpen}">
      <p @click="searchOpen = !searchOpen">검색</p>
      <div class="filter">
        <dl>
          <dt style="display:block;">상태</dt>
          <dd>
            <KSACheckBoxGroup
                ref="applyStateGbsListRef"
                className="mr-md"
                name="applyStateGbsList"
                v-model="searchInput.searchApplyStateGbs"
                :options="applyStateGb"
            />
          </dd>
        </dl>
        <dl>
          <dt>입사지원일</dt>
          <dd class="text-box">
            <div class="grid">
              <template v-for="group in searchDurationTypeGroup" key="item.value" >
                <KSARadioButton class="mr-md" name="searchDurationGb3" :label="group.label" v-model="searchInput.searchDurationType" :value="group.value" />
              </template>
              <div style="display: inline-block;" v-show="searchInput.searchDurationType !== 'all'">
                <KSADatepickerTerms
                    ref="datepickerTermsRef"
                    :startDate="searchInput.startYmd"
                    :endDate="searchInput.endYmd"
                    @update:startDate="(value)=> searchInput.startYmd = value"
                    @update:endDate="(value)=> searchInput.endYmd = value"
                />
              </div>
            </div>
          </dd>
        </dl>
        <dl>
          <dt>
            이름
          </dt>
          <dd>
            <KSAInput class="text-box" v-model="searchInput.searchInput" placeholder="이름을 입력해 주세요." />
          </dd>
        </dl>
        <div class="btn-wrap">
          <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
          <KSAPrimaryButton text="검색" @click="onClickSearch" />
        </div>
      </div>
    </div>
    <!-- e: 검색 -->

    <div class="list-top">
      <p>전체 <span>{{ $number(totalCount)}}</span>건</p>
      <div>
        <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
      </div>
    </div>

    <div class="table-form">
      <table class="horizontal" v-if="userApplyList !== null">
        <tr>
          <th>NO</th>
          <th>기업명</th>
          <th>이름</th>
          <th>관심 카테고리</th>
          <th>이력서보기</th>
          <th>입사 지원일</th>
          <th>상태</th>
          <th>상태변경</th>
        </tr>
        <tr v-for="list in userApplyList">
          <td>{{ list.boardNo }}</td>
          <td class="clickable blue text-overflow">
            <span @click="router.push({name:'CorporationDetail', params:{id: list.corpId}})">{{ list.corpName }}</span>
          </td>
          <td class="clickable blue">
            <span @click="router.push({name:'MemberDetail', params:{id:list.userCd}})">{{list.userName}}</span>
          </td>
          <td>{{ list.interests }}</td>
          <td class="clickable blue"><span @click="onClickViewResume(list.resumeId)">이력서 보기</span></td>
          <td>{{ $yyyymmddHHmmss(list.createDate) }}</td>
          <td>
            <span v-if="list.applyStateGb === '01'">{{ $gbNameKR('APPLY_STATE_GB',list.applyStateGb) }}</span>
            <span v-else-if="list.applyStateGb === '03' || list.applyStateGb === '05'" class="blue">{{ $gbNameKR('APPLY_STATE_GB',list.applyStateGb) }}</span>
            <span v-else-if="list.applyStateGb === '04' || list.applyStateGb === '06'" class="red">{{ $gbNameKR('APPLY_STATE_GB',list.applyStateGb) }}</span>
            <span v-else class="gray">{{ $gbNameKR('APPLY_STATE_GB',list.applyStateGb) }}</span>
          </td>
          <td>
            <div v-if="list.applyStateGb === '01'">
              <KSATextButton class="clickable black_button" text="서류합격" @click="onClickApplyStateGb(list.corpId, list.resumeId, '03')"/>
              &nbsp;
              <KSATextButton class="clickable black_button" text="서류불합격" @click="onClickApplyStateGb(list.corpId, list.resumeId, '04')"/>
            </div>
            <div v-else-if="list.applyStateGb === '03'">
              <KSATextButton class="clickable black_button" text="서류불합격" @click="onClickApplyStateGb(list.corpId, list.resumeId, '04')"/><br/>
              <KSATextButton class="clickable black_button" text="최종합격" @click="onClickApplyStateGb(list.corpId, list.resumeId, '05')"/>
              &nbsp;
              <KSATextButton class="clickable black_button" text="최종불합격" @click="onClickApplyStateGb(list.corpId, list.resumeId, '06')"/>
            </div>
            <div v-else-if="list.applyStateGb === '04'">
              <KSATextButton class="clickable black_button" text="서류합격" @click="onClickApplyStateGb(list.corpId, list.resumeId, '03')"/><br/>
            </div>
            <div v-else-if="list.applyStateGb === '05'">
              <KSATextButton class="clickable black_button" text="최종불합격" @click="onClickApplyStateGb(list.corpId, list.resumeId, '06')"/><br/>
            </div>
            <div v-else-if="list.applyStateGb === '06'">
              <KSATextButton class="clickable black_button" text="최종합격" @click="onClickApplyStateGb(list.corpId, list.resumeId, '05')"/><br/>
            </div>
            <div v-else>
              -
            </div>
          </td>
        </tr>
      </table>
      <div class="result-none" v-if="userApplyList.length === 0">
        입사지원 내역이 없습니다.
      </div>
    </div>
    <Paginate
        v-if="userApplyList.length > 0"
        v-model="currentPage"
        :page-count="totalPages"
        :click-handler="onSelectPage"
    />
  </div>
  <MyPageResumeModal ref="userMatchingResumeModal"/>
</template>

<style lang="scss" scoped>
@import "../../../../assets/scss/theme";

.blue {
  color: $blue_color;
}
.clickable {
  text-decoration: underline;
  cursor: pointer;
}
</style>